
import { defineComponent } from "vue";
import CardToolbarMenuItem from './CardToolbarMenuItem.vue';

export default defineComponent({
  components: {CardToolbarMenuItem},
});
